import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/cashwheel/cash.png'
import _imports_1 from '@/assets/cashwheel/pddv2_top_money.png'
import _imports_2 from '@/assets/cashwheel/pddv2_pop_btn_sacar.png'


const _hoisted_1 = { class: "pop_content" }
const _hoisted_2 = { class: "money_amount" }
const _hoisted_3 = { class: "amount_text" }
const _hoisted_4 = { class: "bar_container" }
const _hoisted_5 = { class: "bar" }
const _hoisted_6 = { class: "paymeny_method" }

import { ref, computed } from 'vue'
import ShareContent from './shareContent.vue'
import { formatCurrency } from '@/utils/commonFunction'
import ReportData from './reportData.vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'winPopup',
  setup(__props, { expose: __expose }) {

const show = ref(false)
const sharePopupRef = ref()
const animatedValue = ref(0)
const resData = ref()
const progressPercentage = computed(() => resData.value.user_pdd_info.current_progress / 100);

const assistList = ref({
    assists: [],
    rewards: [
        {
            coin: 10000,
            content: "Acabou de sacar",
            phone: "5569966036826"
        },
        {
            coin: 10000,
            content: "Acabou de sacar",
            phone: "5529955672359"
        },
        {
            coin: 10000,
            content: "Acabou de sacar",
            phone: "5537992670787"
        },
        {
            coin: 10000,
            content: "Acabou de sacar",
            phone: "5534939022762"
        },
        {
            coin: 10000,
            content: "Acabou de sacar",
            phone: "5559935934836"
        },
        {
            coin: 10000,
            content: "Acabou de sacar",
            phone: "5548966762018"
        },
        {
            coin: 10000,
            content: "Acabou de sacar",
            phone: "5529929388973"
        },
        {
            coin: 10000,
            content: "Acabou de sacar",
            phone: "5527998799919"
        },
        {
            coin: 10000,
            content: "Acabou de sacar",
            phone: "5514912448710"
        },
        {
            coin: 10000,
            content: "Acabou de sacar",
            phone: "5575967865248"
        },

        {
            coin: 10000,
            content: "Acabou de sacar",
            phone: "5543972354561"
        },
        {
            coin: 10000,
            content: "Acabou de sacar",
            phone: "5548954560432"
        },
        {
            coin: 10000,
            content: "Acabou de sacar",
            phone: "5517935598177"
        },
        {
            coin: 10000,
            content: "Acabou de sacar",
            phone: "5569929029201"
        }
    ]
})

const open = (data: any) => {
    show.value = true
    resData.value = data

    const target = resData.value.user_pdd_info.current_progress / 100
    animateValue(0, target, 800)
}
const close = () => {
    show.value = false
}
const showSharePopup = () => {
    sharePopupRef.value.open()
}
const animateValue = (start: number, end: number, duration: number) => {
    const startTime = performance.now()

    const step = (currentTime: number) => {
        const progress = Math.min((currentTime - startTime) / duration, 1)
        animatedValue.value = start + (end - start) * progress

        if (progress < 1) {
            requestAnimationFrame(step)
        } else {
            animatedValue.value = end
        }
    }

    requestAnimationFrame(step)
}

__expose({
    open,
    close
})

return (_ctx: any,_cache: any) => {
  const _component_van_col = _resolveComponent("van-col")!
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_row = _resolveComponent("van-row")!
  const _component_van_popup = _resolveComponent("van-popup")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_van_popup, {
      show: show.value,
      "onUpdate:show": _cache[0] || (_cache[0] = ($event: any) => ((show).value = $event)),
      round: "",
      "overlay-style": { overflow: 'hidden' },
      style: {
        width: '80%',
        Height: '50%',
        background: '#27190D',
        borderRadius: '30px'
    }
    }, {
      default: _withCtx(() => [
        _createVNode(_component_van_row, { class: "popup_head" }, {
          default: _withCtx(() => [
            _createVNode(_component_van_col, {
              span: "20",
              offset: "2",
              class: "alignements"
            }, {
              default: _withCtx(() => _cache[1] || (_cache[1] = [
                _createElementVNode("img", {
                  src: _imports_0,
                  alt: ""
                }, null, -1),
                _createTextVNode(" Receba R$ 100 de graça ")
              ])),
              _: 1
            }),
            _createVNode(_component_van_col, {
              span: "2",
              class: "alignements"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", {
                  class: "close_icon alignements",
                  onClick: close
                }, [
                  _createVNode(_component_van_icon, { name: "cross" })
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_1, [
          _cache[4] || (_cache[4] = _createElementVNode("div", { class: "total_text1" }, "SAQUE RÁPIDO", -1)),
          _cache[5] || (_cache[5] = _createElementVNode("div", { class: "total_text" }, "Parabéns pela sua boa sorte, você ganhou", -1)),
          _createElementVNode("div", _hoisted_2, [
            _cache[2] || (_cache[2] = _createElementVNode("img", {
              src: _imports_1,
              alt: ""
            }, null, -1)),
            _cache[3] || (_cache[3] = _createElementVNode("div", { class: "currency_text" }, "R$", -1)),
            _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(formatCurrency)(animatedValue.value)), 1)
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", {
                class: "progress",
                style: _normalizeStyle({ width: resData.value.user_pdd_info.current_progress / 100 + '%' })
              }, null, 4),
              _createElementVNode("div", {
                class: "progress-end-value",
                style: _normalizeStyle({ left: `calc(${progressPercentage.value}% - 45px)` })
              }, _toDisplayString(resData.value.user_pdd_info.current_progress / 100 + '%'), 5),
              _createElementVNode("div", {
                class: "progress-end-dot",
                style: _normalizeStyle({ left: `calc(${progressPercentage.value}% - 30px)` })
              }, null, 4)
            ])
          ]),
          _createElementVNode("div", { class: "btn_container" }, [
            _createElementVNode("img", {
              src: _imports_2,
              alt: "",
              onClick: showSharePopup
            })
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(ReportData, {
              dataList: assistList.value.rewards,
              reportDataHeight: "115px",
              reportDataMargin: "0",
              colPadding: "2px",
              currencySpanTextSize: "10px",
              currencyTextSize: "9px",
              isReverse: true
            }, null, 8, ["dataList"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(ShareContent, {
      ref_key: "sharePopupRef",
      ref: sharePopupRef
    }, null, 512)
  ], 64))
}
}

})